<template>
  <not-found v-if="!ctaPremission"></not-found>
  <div v-else>
    <HeaderSteps :title="`Edit ${flight?.name}`" :back-path="-1"></HeaderSteps>
    <template v-if="currentStep === 0">
      <CampaignPeriod @step="getCurrentStep" :loading="loading" />
    </template>
    <template v-if="currentStep === 1">
      <Assets />
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Assets from '@/components/social-products/social-boost/forms/Assets.vue'
import NotFound from '@/views/model_not_found/NotFound.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'

export default {
  name: 'CreateFlight',
  mixins: [SocialBoostCampaignMixin],
  components: {
    HeaderSteps,
    CampaignPeriod,
    Assets,
    NotFound,
  },
  data() {
    return {
      steps: ['Period and budget', 'Assets'],
      currentStep: 0,
      loading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign', 'flight']),
    ...mapGetters('app', ['is_loading']),
    ctaPremission() {
      return this.flight ? [0, 1].includes(this.flight.status) : true
    },
  },
  methods: {
    getCurrentStep(step) {
      this.currentStep = step === 2 ? 1 : step
    },
    async init() {
      this.loading = true
      await this.updateStoreFormDetails()
      await this.$store.dispatch('socialBoostCampaign/getFlight', {
        id: this.$route.params.id,
        flight_id: this.$route.params.flight_id,
        pageLoading: false,
      })
      this.loading = false
    },
  },
}
</script>
